<p>purchases works!</p>
